.privacy-consent__modal {
  max-width: 30rem;
  width: 100%;
}
